// @flow
import Button from 'antd/lib/button';
import Checkbox from 'antd/lib/checkbox';
import Modal from 'antd/lib/modal';
import notification from 'antd/lib/notification';
import {FormikProps} from 'formik';

import moment from 'moment';
import React, {Component} from 'react';
import {Form} from '../../../../components';
import {StyledInputNumber} from '../../../../components/hoc/common/components/elements';
import {Grid, GridItem, Section} from '../../../../components/layout';
import {notificationLoading} from '../../../../components/Notifications';
import {AntTable, ButtonsRow} from '../../../../components/ui';
import {TableHeader} from '../../../../components/ui/Table';

import {cargoPassCalculationApi, springPassCalculationApi, vehiclePlanApi} from '../../../../lib/api';
import {accessTypeEnum, calculationStatusEnum, vehiclePlanStatusEnum} from '../../../../lib/enum';
import {getListInitialState, plus, toLocalStringRu} from '../../../../lib/helpers';
import {printNotification} from '../../../../lib/notificationWrapper';
import type {CalculationStatus, ListState, SpringPassCalculation, UserAccess, VehiclePlan} from '../../../../lib/types';
import {withUserAccess} from '../../../withUserAccess';
import {canEditBudget} from '../accessRight';

import type {VehicleListFilterParams} from '../components/FilterVehicleList';
import Filter from '../components/FilterVehicleList';

import {COGNOS_DELTA, COLUMNS, filteredData, MONTH} from '../lib';

import {headerPanel} from './components/Common';
import styled from 'styled-components';
import TotalBlock from './components/TotalBlock';
import InfoBlock from '../components/InfoBlock';
import {EditingModal} from './components/EditingModal';
import {dateIsIncludeInOpenPeriod, getOpenPeriod} from '../../contractVehicle/fixed/lib';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

type Props = {
  location: Location & { state: { page: number } },
  vehiclePlanId: number,
  userAccess: UserAccess[]
};

type State = ListState<SpringPassCalculation> & {
  vehiclePlan: VehiclePlan,
  columns: any,
  filter: VehicleListFilterParams,
  visible: boolean,
  springPassCalculation: ?SpringPassCalculation,
  cargoPassTotalValue: ?number,
  editingModalVisible: boolean,
  rowData: ?SpringPassCalculation,
  monthIndex: number,
  cognosData: ?number,
  openPeriod?: {
    start: string,
    end: string,
  },
  hasUnsavedValues: boolean,
};

const SpringPass = class extends Component<Props, State> {
  onRow = (springPassCalculation: SpringPassCalculation) => {
    return {
      onClick: this.isDraft()
        ? () => {
          this.setState({
            visible: true,
            springPassCalculation: {...springPassCalculation},
          });
        }
        : undefined,
    };
  };

  onCell = (data: SpringPassCalculation, monthIndex: number) => ({
    onClick: e => {
      if (!this.canEdit()) {
        return;
      }
      const {openPeriod, vehiclePlan} = this.state;
      const date = moment().month(monthIndex).format();
      if (vehiclePlan?.status === vehiclePlanStatusEnum.approvementAfterCognos &&
          vehiclePlan?.springPassCalculationStatus === calculationStatusEnum.draft && data.id &&
          dateIsIncludeInOpenPeriod(openPeriod, date)) {
        e.stopPropagation();
        this.setState({
          rowData: data,
          monthIndex,
          editingModalVisible: true,
        });
      }
    },
  });
  async componentDidMount() {
    this.getData();
    if (this.props.vehiclePlanId) {
      this.setState({openPeriod: await getOpenPeriod(this.props.vehiclePlanId)});
    }
  }
  isRangeMonths = (monthIndex: number) => {
    const {vehiclePlan} = this.state;
    if (vehiclePlan?.startDate && vehiclePlan?.endDate) {
      const start = moment(vehiclePlan.startDate).get('month');
      const end = moment(vehiclePlan.endDate).get('month');
      return start <= monthIndex && end >= monthIndex;
    }
    return false;
  };
  // дата после списания
  afterPlannedWriteoffDate = (
    monthIndex: number,
    plannedWriteoffDate?: ?string,
  ) => {
    const {vehiclePlan} = this.state;
    if (vehiclePlan && plannedWriteoffDate) {
      const year = moment(vehiclePlan.date).get('year');
      return moment(`${year}-${monthIndex + 1}-01`).isAfter(
        plannedWriteoffDate,
        'month',
      );
    }
    return false;
  };
  getData = async () => {
    this.setState({loading: true});
    try {
      await this.getVehiclePlan();
      await this.fetch();
    } finally {
      this.setState({loading: false});
    }
  };
  getVehiclePlan = async () => {
    const {vehiclePlanId} = this.props;
    try {
      const vehiclePlan = await vehiclePlanApi.get(vehiclePlanId);
      this.setState({vehiclePlan});
    } catch (error) {
      notification.warning({message: 'Не удалось запросить данные'});
    }
  };
  fetch = async () => {
    const {vehiclePlanId} = this.props;
    try {
      let {data} = await springPassCalculationApi.fetch({
        vehiclePlanId,
        page: undefined,
        pageSize: undefined,
      });
      let {data: cargoData} = await cargoPassCalculationApi.fetch({
        vehiclePlanId,
        page: undefined,
        pageSize: undefined,
      });
      this.setState({
        cargoPassTotalValue: this.itogCalculation(cargoData).sum,
      });
      if (!data) {
        notification.warning({message: 'Не удалось запросить данные'});
        return;
      }
      this.setState({data});
    } catch (error) {
      notification.error({message: error.message});
    }
  };
  handleSave = async (springPassCalculation: SpringPassCalculation) => {
    const {data} = this.state;
    this.setState({loading: true});
    const rowIndex = data.findIndex(
      item => item.id === springPassCalculation.id,
    );
    try {
      if (springPassCalculation && rowIndex !== -1) {
        let update = await springPassCalculationApi.calculation.update(
          springPassCalculation,
        );

        data[rowIndex] = update;
        this.setState({ data, hasUnsavedValues: true });
      }
    } catch (error) {
      notification.warning({message: 'Не удалось обновить данные' + error});
    } finally {
      this.setState({
        loading: false,
        visible: false,
        springPassCalculation: null,
      });
    }
  };
  handleCancel = () => {
    this.setState({
      visible: false,
      springPassCalculation: null,
      editingModalVisible: false,
      rowData: null,
      monthIndex: null,
    });
  };
  changeStatus = async (status: CalculationStatus) => {
    const {vehiclePlanId} = this.props;
    try {
      notificationLoading({
        message: 'Сохранение данных',
        key: 'saving',
      });
      await springPassCalculationApi.changeStatus(vehiclePlanId, status);
      this.getData();
    } catch (error) {
      notification.error({message: 'Не удалось обновить данные данные'});
    } finally {
      notification.close('saving');
    }
  };
  calculate = async () => {
    const {vehiclePlanId} = this.props;
    const {data} = this.state;
    try {
      notificationLoading({
        message: 'Сохранение данных',
        key: 'saving',
      });
      if (data.length === 0) {
        await springPassCalculationApi.calculate(vehiclePlanId);
      } else {
        await springPassCalculationApi.updateCalculations(vehiclePlanId);
      }
      this.getData();
      this.setState({hasUnsavedValues: false});
    } catch (error) {
      notification.error({message: 'Не удалось обновить данные данные'});
    } finally {
      notification.close('saving');
    }
  };
  isDraft = () =>
    this.state.vehiclePlan?.springPassCalculationStatus ===
    calculationStatusEnum.draft;
  state = {
    ...getListInitialState(),
    vehiclePlan: null,
    filter: {},
    columns: [
      ...COLUMNS,
      {
        title: (
          <TableHeader width="120px">
            Тариф за превышение допустимой нормы
          </TableHeader>
        ),
        dataIndex: 'excessRate',
        render: excessRate =>
          toLocalStringRu(excessRate, {minimumFractionDigits: 2}),
      },
      {
        title: <TableHeader width="120px">Тариф госпошлины</TableHeader>,
        dataIndex: 'taxRate',
        render: taxRate =>
          toLocalStringRu(taxRate, {minimumFractionDigits: 2}),
      },
      {
        title: (
          <TableHeader width="120px">Планируемый пробег, км в день</TableHeader>
        ),
        dataIndex: 'plannedKilometrage',
        render: plannedKilometrage => toLocalStringRu(plannedKilometrage),
      },
      {
        title: (
          <TableHeader width="120px">
            Планируемое кол-во рабочих дней в месяц
          </TableHeader>
        ),
        dataIndex: 'workDaysCount',
        render: workDaysCount => toLocalStringRu(workDaysCount),
      },
      ...MONTH.map((month, index) => ({
        title: month.title,
        dataIndex: 'month.isCalculationNeeded',
        key: `${index}isCalculationNeeded`,
        children: [
          {
            title: 'Пропуск',
            key: `months${index}cost`,
            dataIndex: `months[${index}].cost`,
            render: cost => (
              <span
                className={
                  this.isDraft() && this.isRangeMonths(index)
                    ? 'link-text'
                    : null
                }
              >
                {toLocalStringRu(cost, {minimumFractionDigits: 2})}
              </span>
            ),
            onCell: monthData => this.onCell(monthData, index),
          },
          {
            title: 'Гос. пошлина',
            key: `months${index}tax`,
            dataIndex: `months[${index}].tax`,
            render: tax => (
              <span
                className={
                  this.isDraft() && this.isRangeMonths(index)
                    ? 'link-text'
                    : null
                }
              >
                {toLocalStringRu(tax, {minimumFractionDigits: 2})}
              </span>
            ),
            onCell: monthData => this.onCell(monthData, index),
          },
          {
            title: 'Итого',
            key: `months${index}sum`,
            dataIndex: `months[${index}].tax`,
            className: 'primary-background',
            render: (tax, row: SpringPassCalculation) => {
              const sum = plus(tax, row.months[index].cost);
              return (
                <span
                  className={
                    this.isDraft() && this.isRangeMonths(index)
                      ? 'link-text'
                      : null
                  }
                >
                  {toLocalStringRu(sum, {minimumFractionDigits: 2})}
                </span>
              );
            },
            onCell: monthData => this.onCell(monthData, index),
          },
        ],
      })),
      {
        title: (
          <TableHeader width="120px">
            Итого годовая сумма в руб на пропуска. без НДС
          </TableHeader>
        ),
        dataIndex: 'passSum',
        render: passSum =>
          toLocalStringRu(passSum, {minimumFractionDigits: 2}),
      },
      {
        title: (
          <TableHeader width="130px">
            Итого годовая сумма в руб на пошлину руб. без НДС
          </TableHeader>
        ),
        dataIndex: 'taxSum',
        render: taxSum => toLocalStringRu(taxSum, {minimumFractionDigits: 2}),
      },
      {
        title: (
          <TableHeader width="120px">
            Итого годовая сумма в руб на ТС
          </TableHeader>
        ),
        dataIndex: 'sum',
        render: sum => toLocalStringRu(sum, {minimumFractionDigits: 2}),
      },
    ],
    visible: false,
    editingModalVisible: false,
    springPassCalculation: null,
    cargoPassTotalValue: null,
    rowData: null,
    monthIndex: null,
    hasUnsavedValues: false,
  };
  itogCalculation = (data: any) => {
    const itog = {
      // $FlowFixMe
      months: Array(12)
      .fill()
      .map(() => ({cost: 0, tax: 0, itog: 0, passSum: 0, taxSum: 0})),
      sum: 0,
      taxSum: 0,
      passSum: 0,
    };
    data.forEach((item: any) => {
      itog.sum = plus(itog.sum, item.sum);
      itog.taxSum = plus(itog.taxSum, item.taxSum);
      itog.passSum = plus(itog.passSum, item.passSum);
      item.months.forEach((month: any, index) => {
        itog.months[index].cost = plus(
          itog.months[index].cost,
          month.cost ?? 0,
        );
        itog.months[index].tax = plus(itog.months[index].tax, month.tax ?? 0);
        itog.months[index].passSum = plus(
          itog.months[index].passSum,
          month.passSum ?? 0,
        );
        itog.months[index].taxSum = plus(
          itog.months[index].taxSum,
          month.taxSum ?? 0,
        );
        itog.months[index].itog = plus(
          itog.months[index].tax,
          itog.months[index].cost,
        );
      });
    });
    return itog;
  };

  applyFilter = (filter: VehicleListFilterParams) => this.setState({filter});

  cleanFilter = () => this.setState({filter: {}});

  handlePrint = () => {
    printNotification(async () => {
      await springPassCalculationApi.print(
        this.props.vehiclePlanId,
        this.state.filter,
      );
    });
  };

  handleEditingDataSave = async data => {
    try {
      notificationLoading({message: 'Сохранение данных', key: 'saving'});
      await springPassCalculationApi.calculation.update(data);
      await this.fetch();
      this.handleCancel();
    } catch (e) {
      notification.error({
        message: 'Ошибка',
        description: e.message,
      });
    } finally {
      notification.close('saving');
    }
  };

  canEdit = () =>
    this.props.userAccess.some(access =>
      [
        accessTypeEnum.editingBudgetCopy,
        accessTypeEnum.admin,
        accessTypeEnum.adminBranch,
      ].includes(access),
    );

  render() {
    const {vehiclePlanId} = this.props;
    const {
      columns,
      visible,
      loading,
      data,
      filter,
      springPassCalculation,
      vehiclePlan,
      editingModalVisible,
      rowData,
      monthIndex,
      cognosData,
    } = this.state;
    const filtered = filteredData(data, filter);
    const itog = this.itogCalculation(filtered);
    const planApproved = vehiclePlan?.status === vehiclePlanStatusEnum.approved;
    const isCognosStatus =
      vehiclePlan?.status === vehiclePlanStatusEnum.approvedAfterCognos ||
      vehiclePlan?.status === vehiclePlanStatusEnum.approvementAfterCognos;
    const approveButtonIsDisabled = (!isCognosStatus && this.props.userAccess.includes(accessTypeEnum.admin))
        ? false
        : Math.abs(itog?.sum + this.state.cargoPassTotalValue - cognosData) > COGNOS_DELTA;

    return (
      <>
        {headerPanel({
          vehiclePlanId,
          vehiclePlan,
          title: 'Пропуска весенний период',
          passTab: true,
        })}
        <Section>
          <InfoBlock links={{'Тарифы на пропуска': '/admin/pass-tariff'}} />
          <div style={{padding: '16px 16px 0px'}}>
            <Filter
              vehicleType={true}
              filter={filter}
              applyFilter={this.applyFilter}
              cleanFilter={this.cleanFilter}
              vehiclePlanId={vehiclePlanId}
            />
          </div>
          <AntTable
            loading={loading}
            data={filtered.length !== 0 ? [...filtered, itog] : []}
            columns={columns}
            onRow={!isCognosStatus && this.onRow}
            bordered
            scroll={{
              x: 7000,
              y: 'calc(100vh - 560px)',
            }}
            pagination={{pageSize: 50}}
            rowClassName={record => record.selfVehiclePlanVehicle?.changed && this.isDraft()
              ? 'table-row-error'
              : null
            }
          />
          <ModalSpringPass
            visible={visible}
            handleSave={this.handleSave}
            handleCancel={this.handleCancel}
            springPassCalculation={springPassCalculation}
            isRangeMonths={this.isRangeMonths}
            afterPlannedWriteoffDate={this.afterPlannedWriteoffDate}
          />
          {rowData && (
            <EditingModal
              visible={editingModalVisible}
              handleCancel={this.handleCancel}
              handleSave={this.handleEditingDataSave}
              data={rowData}
              monthIndex={monthIndex}
              type="passes"
            />
          )}
        </Section>
        <Section style={{padding: '16px'}}>
          <Wrapper>
            {isCognosStatus && (
              <TotalBlock
                filteredDataTotalSum={itog?.sum}
                controllerName="springPassCalculation"
                vehiclePlanId={vehiclePlanId}
                additionalData={{
                  cargoPassTotal: this.state.cargoPassTotalValue,
                }}
                setCognosData={cognosData => this.setState({cognosData})}
              />
            )}
            <ButtonsRow>
              {canEditBudget(this.props.userAccess) && (
                <>
                  {this.isDraft() && (
                    <>
                      {!isCognosStatus && !loading && (
                        <Button type="primary" onClick={this.calculate}>
                          {data.length === 0 ? 'Сформировать' : 'Рассчитать'}
                        </Button>
                      )}
                      <Button
                        type="primary"
                        onClick={() =>
                          this.changeStatus(
                            calculationStatusEnum.calculationDone,
                          )
                        }
                        disabled={approveButtonIsDisabled || this.state.hasUnsavedValues}
                        title={
                          approveButtonIsDisabled
                            ? `Итоговые данные и контрольные значения БК не должны различаться больше чем на ${COGNOS_DELTA}`
                            : this.state.hasUnsavedValues
                              ? 'Для утверждения формы затрат необходимо произвести расчет'
                              : undefined
                        }
                      >
                        Утвердить
                      </Button>
                    </>
                  )}
                  {!planApproved &&
                    !this.isDraft() &&
                    vehiclePlan?.status !==
                    vehiclePlanStatusEnum.approvedAfterCognos && (
                      <>
                        <Button
                          type="primary"
                          onClick={() =>
                            this.changeStatus(calculationStatusEnum.draft)
                          }
                        >
                          Редактировать
                        </Button>
                      </>
                    )}
                </>
              )}
              {data.length > 0 && (
                <Button onClick={this.handlePrint}>Печать</Button>
              )}
            </ButtonsRow>
          </Wrapper>
        </Section>
      </>
    );
  }
};

type ModalSpringPassProps = {
  visible: boolean,
  handleSave: Function,
  handleCancel: Function,
  springPassCalculation: ?SpringPassCalculation,
  isRangeMonths: Function,
  afterPlannedWriteoffDate: Function
};

const ModalSpringPass = (props: ModalSpringPassProps) => {
  const {
    visible,
    handleSave,
    handleCancel,
    springPassCalculation,
    isRangeMonths,
    afterPlannedWriteoffDate,
  } = props;
  const onOk = data => {
    handleSave(data);
  };
  const onCancel = () => {
    handleCancel();
  };
  return (
    <Modal
      forceRender
      destroyOnClose
      width={400}
      title="Редактирование"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel}>
          Отмена
        </Button>,
        <Button key="submit" type="primary" form="modal-form" htmlType="submit">
          Сохранить
        </Button>,
      ]}
    >
      <Form initialValues={springPassCalculation} onSubmit={onOk}>
        {(FormField, formikProps: FormikProps) => {
          const {setFieldValue} = formikProps;
          return (
            <form onSubmit={formikProps.handleSubmit} id="modal-form">
              <Grid gutter="16px">
                <GridItem fullWidth>
                  <FormField label="Планируемый пробег, км в день" fast name="plannedKilometrage">
                    {({name, value}) => (
                      <StyledInputNumber
                        name={name}
                        value={value}
                        min={0}
                        onChange={value => setFieldValue(name, value)}
                      />
                    )}
                  </FormField>
                </GridItem>

                <GridItem fullWidth>
                  <FormField label="Планируемое кол-во рабочих дней в месяц" fast name="workDaysCount">
                    {({name, value}) => (
                      <StyledInputNumber
                        name={name}
                        value={value}
                        min={0}
                        onChange={value => setFieldValue(name, value)}
                      />
                    )}
                  </FormField>
                </GridItem>

                {
                  <FormField label="Необходимы пропуска:" fast name="months">
                    {({value}) => {
                      return value
                        ? value.map((val, index) => {
                          return (
                            <GridItem fullWidth key={index}>
                              <Checkbox
                                name={`months[${index}].isCalculationNeeded`}
                                checked={val.isCalculationNeeded}
                                disabled={
                                  !isRangeMonths(index) ||
                                  afterPlannedWriteoffDate(
                                    index,
                                    springPassCalculation
                                      ?.selfVehiclePlanVehicle?.vehicle
                                      ?.plannedWriteoffDate ||
                                    springPassCalculation
                                      ?.selfVehiclePlanVehicle
                                      ?.plannedWriteoffDate,
                                  )
                                }
                                onChange={e =>
                                  setFieldValue(
                                    `months[${index}].isCalculationNeeded`,
                                    e.target.checked,
                                  )
                                }
                              >
                                {MONTH[index].title}
                              </Checkbox>
                            </GridItem>
                          );
                        })
                        : null;
                    }}
                  </FormField>
                }
              </Grid>
            </form>
          );
        }}
      </Form>
    </Modal>
  );
};

export default withUserAccess(SpringPass);
